/**
 * @param {string} selector
 */
export function closeUiDialog(selector) {
	(($) => {
		const el = $(selector);

		if (typeof el.dialog !== 'function') {
			return;
		}

		try {
			const isOpen = el.dialog().dialog('isOpen');

			if (isOpen) {
				el.dialog('destroy');
			}
		} catch (e) {
			console.error(e);
		}
	})(jQuery);
}

/**
 * @callback onOpenBaseJqUiDialog
 * @param {JQueryEventObject} event
 * @param {JQueryUI.DialogUIParams} ui
 * @param {JQueryStatic} jQuery
 */

/**
 * @param {string} selector
 * @param {JQueryUI.DialogOptions|undefined} options
 * @param {onOpenBaseJqUiDialog|undefined} onOpen
 */
export function openJqUiDialog(selector, options = {}, onOpen = undefined) {
	if (window.jQuery === undefined) {
		throw new Error('jQuery is not loaded');
	}

	(($) => {
		const el = $(selector);

		if (typeof el.dialog !== 'function') {
			return;
		}

		if (typeof onOpen === 'function') {
			options.open = function () {
				onOpen(...arguments, $);
			};
		}

		/** @type {JQueryUI.DialogOptions} */
		const dialogConfig = {
			modal: true,
			show: {
				effect: 'fade',
				duration: 100,
			},
			hide: {
				effect: 'fade',
				duration: 300,
			},
			...options,
		};

		el.dialog(dialogConfig);
	})(jQuery);
}

export function showLoginDialog() {
	openJqUiDialog(
		'#dialog',
		{
			width: 660,
			maxWidth: 660,
			height: 'auto',
		},
		(event, ui, $) => {
			$('.ui-widget-overlay').on('click', function () {
				$('.mobile-mode #dialog').dialog('close');
			});
		}
	);
}

/**
 * @param {onOpenBaseJqUiDialog|undefined} onOpen
 */

export function showFBDialog(onOpen = undefined) {
	openJqUiDialog(
		'#fb-continue-dialog',
		{
			width: 1370,
			classes: {
				'ui-dialog': 'add-dialog',
			},
		},
		onOpen
	);
}

export function showBMDialog() {
	openJqUiDialog(
		'#bm-dialog',
		{
			width: 1370,
			classes: {
				'ui-dialog': 'add-dialog',
			},
		},
		(event, ui, $) => {
			const langHtml = document.documentElement.lang;

			const platform = /Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl';

			$('.ui-widget-overlay').addClass('override');

			const textBox = $('#bm-dialog p');

			const messages = {
				es_ES: 'Presione {key} + D para agregar esta página a favoritos.',
				es_MX: 'Presione {key} + D para agregar esta página a favoritos.',
				pt_BR: 'Pressione {key} + D para colocar esta página nos Favoritos.',
				it_IT:
					'Premi {key} + D per aggiungere questa página ai tuoi segnalibri.',
				de_DE:
					'Drücke {key} + D, um ein Lesezeichen für diese Seite zu setzen.',
				fr_FR: 'Appuyez sur {key} + D pour ajouter cette page à vos favoris.',
				default: 'Press {key} + D to bookmark this page.',
			};

			const message = messages[langHtml] || messages['default'];
			textBox.text(message.replace('{key}', platform));
		}
	);
}
